// extracted by mini-css-extract-plugin
export default {"container":"DY-z","list":"EY-z"};